var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "card",
    class: _vm.$style.container
  }, [_vm._m(0), _vm._m(1), _c('a-form', {
    staticClass: "mb-4",
    attrs: {
      "form": _vm.form
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['name', {
        rules: [{
          required: true,
          message: 'Unesite vaše ime i prezime'
        }]
      }],
      expression: "['name', {rules: [{ required: true, message: 'Unesite vaše ime i prezime' }]}]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "Puno ime i prezime"
    }
  })], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['email', {
        rules: [{
          required: true,
          message: 'Unesite vašu email adresu'
        }]
      }],
      expression: "['email', {rules: [{ required: true, message: 'Unesite vašu email adresu' }]}]"
    }],
    attrs: {
      "size": "large",
      "placeholder": "Email Adresa"
    }
  })], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', {
        rules: [{
          required: true,
          message: 'Unesite željenu lozinku'
        }]
      }],
      expression: "['password', {rules: [{ required: true, message: 'Unesite željenu lozinku' }]}]"
    }],
    attrs: {
      "size": "large",
      "type": "password",
      "placeholder": "Lozinka"
    }
  })], 1), _c('a-button', {
    staticClass: "text-center w-100",
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading,
      "htmlType": "submit"
    }
  }, [_c('strong', [_vm._v("Registracija")])])], 1), _vm._m(2)], 1), _c('div', {
    staticClass: "text-center pt-2 mb-auto"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Već imate nalog?")]), _c('router-link', {
    staticClass: "kit__utils__link font-size-16",
    attrs: {
      "to": "/auth/login"
    }
  }, [_vm._v("Prijavite se")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-dark font-size-24 mb-4"
  }, [_c('strong', [_vm._v("Napravite nalog")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-4"
  }, [_c('p', [_vm._v(" Upravljajte kadrovima na efikasan način i uštedite vrijeme za više poslovnih uspjeha. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "mr-1"
  }, [_vm._v("Klikom na registracija saglasni ste sa")]), _c('a', {
    staticClass: "kit__utils__link",
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_vm._v("Uslovima korštenja")]), _vm._v(" i "), _c('a', {
    staticClass: "kit__utils__link",
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_vm._v("Politikom privatnosti")])]);
}]

export { render, staticRenderFns }